<template>
    <general-link class="nav-link"><slot></slot></general-link>
</template>

